import { gql } from "@apollo/client";

// The App API provides the company-scoped, unique-worker count.
// Historical Attendance omits the live count.
export const GET_APP_STAFF_SUMMARY = gql`
    query AppStaffSummary($id: ID!, $subcontractorID: ID, $includeCheckedIn: Boolean!) {
        exhibitionEvent(id: $id) {
            id
            relBookedWorkersSubcontractors {
                id
                subcontractor_id
                booked_workers
                relSubcontractor { id title }
            }
            getAppWorkerSubcontractors { id title }
            getAppCheckedInWorkersCount(subcontractor_id: $subcontractorID) @include(if: $includeCheckedIn)
        }
    }
`;
